export default "__VITE_ASSET__BRu3_4bH__"